import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["modal", "contentFrame"]

  loadContent(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.url

    if (url) {
      // Open the modal
      this.modalTarget.classList.add("is-active")
      document.body.classList.add("modal-open")

      // Set the turbo frame src to load the content
      const frame = document.getElementById("floating-modal-frame")
      if (frame) {
        frame.src = url
      }
      // const frame = this.contentFrameTarget
      // frame.src = url + "?iframe=1"
    }
  }

  close(event) {
    event.preventDefault()
    this.modalTarget.classList.remove("is-active")
    document.body.classList.remove("modal-open")

    // Clear the turbo frame content when closing
    const frame = document.getElementById("floating-modal-frame")
    if (frame) {
      frame.innerHTML = ""
      frame.removeAttribute("src")
    }
  }

  // Close modal when pressing Escape key
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.classList.remove("modal-open")
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.modalTarget.classList.contains("is-active")) {
      this.close(event)
    }
  }
}
